'use strict';
import Choices from 'choices.js';
const axios = require('axios');

const ScientificReviewList = {
    choicesYear: null,
    choicesMonth: null,
    selectYear: null,
    selectYearCurrent: null,
    selectMonth: null,
    selectMonthCurrent: null,
    termList: null,
    searchInput: null,
    submitButton: null,
    form: null,
    loader: null,
    loadMore: null,
    result: null,
    yearSelected: '',
    monthSelected: '',
    termSelected: '',
    searchQuery: '',
    currentPage: 1,
    postPerPage: 5,
    apiUrl: null,
    init: function () {
        if (document.querySelector('.scientificReviewList')) {
            ScientificReviewList.apiUrl = apiData['scientific-review'];
            if (ScientificReviewList.apiUrl) {
                ScientificReviewList.selectYear = document.querySelector('.scientificReviewList__year');
                ScientificReviewList.selectYearCurrent = document.querySelector('.scientificReviewList__year-active');
                ScientificReviewList.selectMonth = document.querySelector('.scientificReviewList__month');
                ScientificReviewList.selectMonthCurrent = document.querySelector('.scientificReviewList__month-active');
                ScientificReviewList.termList = document.querySelectorAll('.scientificReviewList__list button');
                ScientificReviewList.form = document.querySelector('.scientificReviewList__form');
                ScientificReviewList.searchInput = document.querySelector('.scientificReviewList__search');
                ScientificReviewList.submitButton = document.querySelector('.scientificReviewList__form .c-button.submit--');
                ScientificReviewList.loader = document.querySelector('.scientificReviewList__results-loader');
                ScientificReviewList.loadMore = document.querySelector('.scientificReviewList__results-loadMore');
                ScientificReviewList.result = document.querySelector('.scientificReviewList__results-content');

                ScientificReviewList.choicesYear = new Choices(ScientificReviewList.selectYear, { searchEnabled: false, itemSelectText: '', shouldSort: false });
                ScientificReviewList.choicesMonth = new Choices(ScientificReviewList.selectMonth, { searchEnabled: false, itemSelectText: '', shouldSort: false });

                ScientificReviewList.events();
                ScientificReviewList.fetchItems();
            } else {
                console.log("err get api scientific-review");
            }
        }
    },
    events: function () {
        if (ScientificReviewList.selectYear) {
            ScientificReviewList.selectYear.addEventListener('change', (e) => {
                e.preventDefault();
                ScientificReviewList.changeYear(e);
            });
        }

        if (ScientificReviewList.selectYearCurrent) {
            ScientificReviewList.selectYearCurrent.addEventListener('click', (e) => {
                e.preventDefault();
                ScientificReviewList.resetYear();
            });
        }

        if (ScientificReviewList.selectMonth) {
            ScientificReviewList.selectMonth.addEventListener('change', (e) => {
                e.preventDefault();
                ScientificReviewList.changeMonth(e);
            });
        }

        if (ScientificReviewList.selectMonthCurrent) {
            ScientificReviewList.selectMonthCurrent.addEventListener('click', (e) => {
                e.preventDefault();
                ScientificReviewList.resetMonth();
            });
        }

        if (ScientificReviewList.loadMore) {
            ScientificReviewList.loadMore.addEventListener('click', (e) => {
                e.preventDefault();
                ScientificReviewList.loadMore.classList.remove('show--');
                ScientificReviewList.currentPage += 1;
                ScientificReviewList.fetchItems();
            });
        }

        if (ScientificReviewList.termList) {
            ScientificReviewList.termList.forEach(button => {
                button.addEventListener('click', (e) => {
                    e.preventDefault();
                    ScientificReviewList.changeTerm(button);
                });
            });
        }

        if (ScientificReviewList.searchInput) {
            ScientificReviewList.searchInput.addEventListener('input', () => {
                const val = ScientificReviewList.searchInput.value.trim();
                if (val.length >= 3) {
                    ScientificReviewList.submitButton.removeAttribute('disabled');
                } else {
                    ScientificReviewList.submitButton.setAttribute('disabled', true);
                    if (val.length === 0 && ScientificReviewList.searchQuery !== '') {
                        ScientificReviewList.searchQuery = '';
                        ScientificReviewList.resetAllParams();
                    }
                }
            });
        }

        if (ScientificReviewList.form) {
            ScientificReviewList.form.addEventListener('submit', (e) => {
                e.preventDefault();
                ScientificReviewList.searchQuery = ScientificReviewList.searchInput.value.trim();
                ScientificReviewList.resetAllParams();
            });
        }
    },
    changeYear: function (e) {
        const selectedYear = e.target.value;
        if (selectedYear !== "0") {
            ScientificReviewList.yearSelected = selectedYear;
            ScientificReviewList.selectYearCurrent.innerHTML = `<button type="button" class="c-button list-- current--">${selectedYear}<span></span></button>`;
            ScientificReviewList.choicesYear.setChoiceByValue("0");
            ScientificReviewList.resetAllParams();
        }
    },
    resetYear: function () {
        ScientificReviewList.selectYearCurrent.innerHTML = '';
        ScientificReviewList.yearSelected = '';
        ScientificReviewList.choicesYear.setChoiceByValue("0");
        ScientificReviewList.resetAllParams();
    },
    changeMonth: function (e) {
        const selectedMonth = e.target.value;
        const selectedText = e.target.options[e.target.selectedIndex].text;
        if (selectedMonth !== "0") {
            ScientificReviewList.monthSelected = selectedMonth;
            ScientificReviewList.selectMonthCurrent.innerHTML = `<button type="button" class="c-button list-- current--">${selectedText}<span></span></button>`;
            ScientificReviewList.choicesMonth.setChoiceByValue("0");
            ScientificReviewList.resetAllParams();
        }
    },
    resetMonth: function () {
        ScientificReviewList.selectMonthCurrent.innerHTML = '';
        ScientificReviewList.monthSelected = '';
        ScientificReviewList.choicesMonth.setChoiceByValue("0");
        ScientificReviewList.resetAllParams();
    },
    changeTerm: function (button) {
        ScientificReviewList.termList.forEach(btn => btn.classList.remove('current--'));
        button.classList.add('current--');
        ScientificReviewList.termSelected = button.getAttribute('data-term');
        ScientificReviewList.resetAllParams();
    },
    resetAllParams: function () {
        ScientificReviewList.currentPage = 1;
        ScientificReviewList.result.innerHTML = "";
        ScientificReviewList.loadMore.classList.remove('show--');
        ScientificReviewList.fetchItems();
    },
    fetchItems: function () {
        ScientificReviewList.loader.classList.add('show--');
        const url = `${ScientificReviewList.apiUrl}&posts_per_page=${ScientificReviewList.postPerPage}&year=${ScientificReviewList.yearSelected}&month=${ScientificReviewList.monthSelected}&taxonomy_term=${ScientificReviewList.termSelected}&search=${encodeURIComponent(ScientificReviewList.searchQuery)}&page=${ScientificReviewList.currentPage}`;
        axios({
            method: "get",
            url: url,
            headers: { "Content-Type": "multipart/form-data" },
        }).then(function (response) {
            if (response.status === 200) {
                if (response.data && response.data.total > 0) {
                    if (response.data.totalPages > ScientificReviewList.currentPage) {
                        ScientificReviewList.loadMore.classList.add('show--');
                    } else {
                        ScientificReviewList.loadMore.classList.remove('show--');
                    }
                    let html = '';
                    response.data.items.forEach((elt) => {
                        html += `<a href="${elt.link.url}" class="c-button text--" title="${elt.link.title}" target="${elt.link.target}">
                                    <div class="c-push horizontal-- large--">
                                        <div class="c-push__img c-img">
                                            <div class="figure">
                                                <picture>
                                                    <img src="${elt.image.url}" alt="${elt.image.alt}" />
                                                </picture>
                                            </div>
                                        </div>
                                        <div class="c-push__content">
                                            <h3 class="c-push__title underline--">${elt.title}</h3>
                                            ${elt.date ?
                                                `<p class="c-push__date c-date small--">
                                                    <span class="c-date__day">${elt.date.day} ${elt.date.month}</span>
                                                    <span class="c-date__year">${elt.date.year}</span>
                                                </p>`
                                                :
                                                '<p class="c-push__date c-date small--"></p>'
                                            }
                                            ${elt.excerpt ? `<div class="c-push__excerpt"><p>${elt.excerpt}</p></div>` : ''}
                                            <div class="c-push__link">
                                                <div class="c-button__elt"><span>${elt.link.title}</span><i class="icon-arrow" aria-hidden="true"></i></div>
                                            </div>
                                        </div>
                                    </div>
                                </a>`;
                    });
                    ScientificReviewList.result.insertAdjacentHTML('beforeend', html);
                } else {
                    ScientificReviewList.result.innerHTML = ScientificReviewList.result.getAttribute('data-noresult');
                    ScientificReviewList.loadMore.classList.remove('show--');
                }
            } else {
                console.log('Error:', response.statusText);
            }
            ScientificReviewList.loader.classList.remove('show--');
        }).catch(function (error) {
            console.log('err', error);
            ScientificReviewList.loader.classList.remove('show--');
        });
    }
};

export default ScientificReviewList;
